/** Horizontal space reserved for the right Y-axis (must stay in sync with BandChart x-scale range). */
export const BAND_CHART_RIGHT_PADDING = 65;

/** Bottom margin reserved for the x-axis (must stay in sync with BandChart y-scale range). */
export const BAND_CHART_MARGIN_BOTTOM = 50;

/** Default `<svg>` plot height for `BandChart` (`Plot`). */
export const BAND_CHART_DEFAULT_PLOT_HEIGHT_PX = 180;
